import IState from '@/interfaces/IState';
import ITicket from "@/interfaces/ITicket";

export default (state: IState) => (): ITicket[] => {
  return state.tickets || [];
};
